import { mediaUrls } from 'globalconfig/constants/mediaUrls';
import { loadStyle } from 'globalutils/fmUtils';
import PropTypes from 'prop-types';
import React, { lazy, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Carousel } from 'react-responsive-carousel';
import 'react-responsive-carousel/lib/styles/carousel.min.css';
import { columns } from './config';
import ParentStyled from './style';

const layout = window?.$environment?.CURRENT_LAYOUT;
const Table = lazy(() => import(`globalcomponents/UI/Table/${layout}`));
const SubHeader = lazy(() => import(`globalcomponents/SubHeader/${layout}`));
const Icon = lazy(() => import(`globalcomponents/UI/Icon/${layout}`));
const Styled = loadStyle(ParentStyled, 'modules/WorkOrdersManagement');

const DefectList = ({ defects, getDocumentToken, setOpen, setModalObject }) => {
  const beBaseUrl = window?.$environment?.BE_BASE_URL;
  const [pagination, setPagination] = useState(false);
  const { i18n } = useTranslation();

  const viewPictureCallback = (type, data, currentItem) => {
    currentItem &&
      setModalObject({
        header: '',
        content: () => {
          return (
            <Carousel showIndicators={false} showThumbs={false} showStatus={false}>
              {currentItem.inspectionFiles.map((photo) => {
                return (
                  <div style={{ minHeight: '100px' }}>
                    <img alt="" src={`${beBaseUrl}/document/open/${photo.id}?token=${data}`} />
                    <p className="legend">{`${photo?.documentType?.fullName}`}</p>
                  </div>
                );
              })}
            </Carousel>
          );
        },
      });
    setOpen(true);
  };

  const viewPicture = (item) => {
    getDocumentToken({
      apiId: 'getDocToken',
      callback: viewPictureCallback,
      item: item,
    });
  };

  const generateRows = () => {
    const updatedList = defects.map((item) => {
      let result = { ...item };
      result.mechanicFixStatus = item?.mechanicFixStatus ? 'Fixed' : 'Not Fixed';
      result.driverApproved =
        item?.driverApproved === null || item?.driverApproved === undefined
          ? 'Pending'
          : item.driverApproved
          ? 'Approved'
          : 'Rejected';
      item.viewPhoto = item?.inspectionFiles?.length ? (
        <Icon
          src={mediaUrls?.full}
          tableicon
          onClick={() => {
            viewPicture(item);
          }}
          tooltip={i18n.t('workOrders.viewPhotos')}
        ></Icon>
      ) : (
        <div className="noPointer">
          <Icon src={mediaUrls?.notFull} tableicon></Icon>
        </div>
      );
      return result;
    });
    return updatedList;
  };

  return (
    <>
      <Styled.TableWrapper className="defectList">
        <SubHeader
          className="subheaderSection statusHeader userHeading"
          text={i18n.t('workOrders.defectDetails')}
          variant="h2"
          mode="light"
        />
        <Table
          type="client"
          defaultSortBy={{ sortBy: 'unit_id', order: 'asc' }}
          title=""
          columns={[...columns]}
          data={generateRows()}
          emptyMessage={i18n.t('common.tableEmptyMessage')}
          itemsPerPage={5}
          actions={[]}
          defaultSort={'categoryType'}
          i18n={i18n}
          pageinationReset={pagination}
          pagenationClicked={(e) => {
            setPagination(!e);
          }}
        />
      </Styled.TableWrapper>
    </>
  );
};

DefectList.propTypes = {
  callback: PropTypes.func.isRequired,
  defect: PropTypes.object.isRequired,
};

export default DefectList;
